// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7":"56c81b83","520":"935445ec","611":"71d005ca","808":"f5d6c03b","842":"ba2b1c54"}[chunkId] + ".css";
};